import { isMarketing } from '../marketing/marketingAccessPolicy';
import type { AuthPermissionUser } from '../../services/authPermissions';

export interface InternalTaskAccessUser extends AuthPermissionUser {
  id?: string | null;
}

export interface InternalTaskAccessTask {
  createdById?: string | null;
}

// Internal tasks are blocked for ORDER_STAFF by the backend's default-deny API
// allowlist (backend/src/utils/salesRepPolicy.js); this mirrors that rule.
export function canReadInternalTasks(user: InternalTaskAccessUser | null | undefined): boolean {
  return Boolean(user) && !isMarketing(user) && user?.role !== 'ORDER_STAFF';
}

export function canDeleteInternalTask(
  task: InternalTaskAccessTask | null | undefined,
  user: InternalTaskAccessUser | null | undefined
): boolean {
  if (!task || isMarketing(user)) {
    return false;
  }

  return Boolean(task.createdById && task.createdById === user?.id) || user?.role === 'ADMIN';
}
